/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetUsersOptions,
  GetUsersQuery,
  GetUsersStatus200,
  GetUsersStatus500,
} from '../types/GetUsers'
import type {
  InfiniteData,
  QueryKey,
  QueryClient,
  InfiniteQueryObserverOptions,
  UseInfiniteQueryResult,
} from '@tanstack/react-query'
import { getUsers } from '../clients/getUsers'
import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

export const getUsersInfiniteQueryKey = ({ query }: Omit<GetUsersOptions, 'headers'> = {}) =>
  [{ url: '/v1/user', infinite: true }, ...(query ? [query] : [])] as const

type GetUsersInfiniteQueryKey = ReturnType<typeof getUsersInfiniteQueryKey>

export function getUsersInfiniteQueryOptions(
  { query }: GetUsersOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getUsersInfiniteQueryKey({ query })
  return infiniteQueryOptions<
    GetUsersStatus200,
    ResponseErrorConfig<GetUsersStatus500>,
    InfiniteData<GetUsersStatus200>,
    typeof queryKey,
    NonNullable<GetUsersQuery['offset']>
  >({
    queryKey,
    queryFn: async ({ signal, pageParam }) => {
      query = {
        ...(query ?? {}),
        ['offset']: pageParam as unknown as GetUsersQuery['offset'],
      } as GetUsersQuery
      return getUsers({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) =>
      Array.isArray(lastPage) && lastPage.length === 0 ? undefined : lastPageParam + 1,
    getPreviousPageParam: (_firstPage, _allPages, firstPageParam) =>
      firstPageParam <= 1 ? undefined : firstPageParam - 1,
  })
}

/**
 * @summary Get all users (admin only)
 * {@link /v1/user}
 */
export function useGetUsersInfinite<
  TQueryFnData = GetUsersStatus200,
  TError = ResponseErrorConfig<GetUsersStatus500>,
  TData = InfiniteData<TQueryFnData>,
  TQueryKey extends QueryKey = GetUsersInfiniteQueryKey,
  TPageParam = NonNullable<GetUsersQuery['offset']>,
>(
  { query }: { query?: GetUsersOptions['query'] | (() => GetUsersOptions['query']) } = {},
  options: {
    query?: Partial<
      InfiniteQueryObserverOptions<TQueryFnData, TError, TData, TQueryKey, TPageParam>
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getUsersInfiniteQueryKey(resolvedParams)

  const queryResult = useInfiniteQuery(
    {
      ...getUsersInfiniteQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as InfiniteQueryObserverOptions<
      TQueryFnData,
      TError,
      TData,
      TQueryKey,
      TPageParam
    >,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
